/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingCandidate } from '../models/PropertySharingCandidate';
import type { PropertySharingParametersResponse } from '../models/PropertySharingParametersResponse';
import type { PropertySharingPreviewBodyParams } from '../models/PropertySharingPreviewBodyParams';
import type { PropertySharingSetupResponse } from '../models/PropertySharingSetupResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CatalogPropertySharingService {
    /**
     * Read published website availability; policy values use the existing settings API.
     * @returns PropertySharingSetupResponse Ok
     * @throws ApiError
     */
    public static getSetup(): CancelablePromise<PropertySharingSetupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/property-sharing/setup',
        });
    }
    /**
     * Discover bounded authorized identifier categories for reusable URL tags.
     * @param pageToken
     * @returns PropertySharingParametersResponse Ok
     * @throws ApiError
     */
    public static getParameters(
        pageToken?: string,
    ): CancelablePromise<PropertySharingParametersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/property-sharing/parameters',
            query: {
                'pageToken': pageToken,
            },
        });
    }
    /**
     * Preview explicit example values without reading property data or saving configuration.
     * @param requestBody
     * @returns PropertySharingCandidate Ok
     * @throws ApiError
     */
    public static preview(
        requestBody: PropertySharingPreviewBodyParams,
    ): CancelablePromise<PropertySharingCandidate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/property-sharing/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
